
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("aqnVk"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("aqnVk", function(module, exports) {

let $796ee3cec759d7d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $796ee3cec759d7d5$var$load("3VIZM"),
    $796ee3cec759d7d5$var$load("gyh6H"),
    $796ee3cec759d7d5$var$load("1F7LX"),
    $796ee3cec759d7d5$var$load("jZLnv"),
    $796ee3cec759d7d5$var$load("6edij"),
    $796ee3cec759d7d5$var$load("gknbb"),
    $796ee3cec759d7d5$var$load("6iz6l"),
    $796ee3cec759d7d5$var$load("4SCW2"),
    $796ee3cec759d7d5$var$load("36QeB"),
    $796ee3cec759d7d5$var$load("9q75n"),
    $796ee3cec759d7d5$var$load("iYHbd"),
    $796ee3cec759d7d5$var$load("cHb2G"),
    $796ee3cec759d7d5$var$load("8hQ27"),
    $796ee3cec759d7d5$var$load("keNIN"),
    $796ee3cec759d7d5$var$load("hnGEQ"),
    $796ee3cec759d7d5$var$load("3GuOt"),
    $796ee3cec759d7d5$var$load("jbM5v"),
    $796ee3cec759d7d5$var$load("dek7I"),
    $796ee3cec759d7d5$var$load("dYtBN"),
    $796ee3cec759d7d5$var$load("kNV5Y"),
    $796ee3cec759d7d5$var$load("6SWFK"),
    $796ee3cec759d7d5$var$load("9aQIt"),
    $796ee3cec759d7d5$var$load("5zapo"),
    $796ee3cec759d7d5$var$load("3MYQs"),
    $796ee3cec759d7d5$var$load("XZauT"),
    $796ee3cec759d7d5$var$load("4S1SF"),
    $796ee3cec759d7d5$var$load("jiFtb"),
    $796ee3cec759d7d5$var$load("lm9Lt"),
    $796ee3cec759d7d5$var$load("9atVd"),
    $796ee3cec759d7d5$var$load("9wPDc"),
    $796ee3cec759d7d5$var$load("1MWOL"),
    $796ee3cec759d7d5$var$load("6fQco"),
    $796ee3cec759d7d5$var$load("aOY32"),
    $796ee3cec759d7d5$var$load("7jSfd"),
    $796ee3cec759d7d5$var$load("4HZlX"),
    $796ee3cec759d7d5$var$load("kDqHr"),
    $796ee3cec759d7d5$var$load("6wr18"),
    $796ee3cec759d7d5$var$load("gT8XU"),
    $796ee3cec759d7d5$var$load("lE8tR"),
    $796ee3cec759d7d5$var$load("alA4m"),
    $796ee3cec759d7d5$var$load("ffEVr"),
    $796ee3cec759d7d5$var$load("7EorR"),
    $796ee3cec759d7d5$var$load("18TX3"),
    $796ee3cec759d7d5$var$load("eNanj"),
    $796ee3cec759d7d5$var$load("kuFG2"),
    $796ee3cec759d7d5$var$load("Wowvf"),
    $796ee3cec759d7d5$var$load("hhss7"),
    $796ee3cec759d7d5$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("bcWlN"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("bcWlN", function(module, exports) {

let $828e13ed2d89d8d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $828e13ed2d89d8d0$var$load("6wr18"),
    $828e13ed2d89d8d0$var$load("cHb2G"),
    $828e13ed2d89d8d0$var$load("lE8tR"),
    $828e13ed2d89d8d0$var$load("alA4m"),
    $828e13ed2d89d8d0$var$load("ffEVr"),
    $828e13ed2d89d8d0$var$load("cX4Bp"),
    $828e13ed2d89d8d0$var$load("dawn8"),
    $828e13ed2d89d8d0$var$load("aQh37"),
    $828e13ed2d89d8d0$var$load("bJVDE"),
    $828e13ed2d89d8d0$var$load("18TX3"),
    $828e13ed2d89d8d0$var$load("eNanj"),
    $828e13ed2d89d8d0$var$load("kuFG2"),
    $828e13ed2d89d8d0$var$load("1F7LX"),
    $828e13ed2d89d8d0$var$load("3QXpo"),
    $828e13ed2d89d8d0$var$load("hhss7"),
    $828e13ed2d89d8d0$var$load("h3ABO"),
    $828e13ed2d89d8d0$var$load("kC80R"),
    $828e13ed2d89d8d0$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("ePNIe"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("ePNIe", function(module, exports) {

let $accc63f57799543e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $accc63f57799543e$var$load("ez4I6"),
    $accc63f57799543e$var$load("aQMre"),
    $accc63f57799543e$var$load("b9CA3"),
    $accc63f57799543e$var$load("2YffH"),
    $accc63f57799543e$var$load("lUDr0"),
    $accc63f57799543e$var$load("8dwgS"),
    $accc63f57799543e$var$load("9XOeB"),
    $accc63f57799543e$var$load("xu7ej"),
    $accc63f57799543e$var$load("iQ4FP"),
    $accc63f57799543e$var$load("71gca"),
    $accc63f57799543e$var$load("dV37I"),
    $accc63f57799543e$var$load("gdwbX"),
    $accc63f57799543e$var$load("82Jpo"),
    $accc63f57799543e$var$load("eXKRO"),
    $accc63f57799543e$var$load("im1VN"),
    $accc63f57799543e$var$load("bTT9C"),
    $accc63f57799543e$var$load("czOM6"),
    $accc63f57799543e$var$load("5yluq"),
    $accc63f57799543e$var$load("2tcSk"),
    $accc63f57799543e$var$load("8pLtn"),
    $accc63f57799543e$var$load("8auEH"),
    $accc63f57799543e$var$load("jAeEl"),
    $accc63f57799543e$var$load("lKs3T"),
    $accc63f57799543e$var$load("9anPW"),
    $accc63f57799543e$var$load("3EXzu"),
    $accc63f57799543e$var$load("b2FtX"),
    $accc63f57799543e$var$load("gnDXu"),
    $accc63f57799543e$var$load("dl2qY"),
    $accc63f57799543e$var$load("kL5FA"),
    $accc63f57799543e$var$load("6iz6l"),
    $accc63f57799543e$var$load("4SCW2"),
    $accc63f57799543e$var$load("9q75n"),
    $accc63f57799543e$var$load("iYHbd"),
    $accc63f57799543e$var$load("8hQ27"),
    $accc63f57799543e$var$load("keNIN"),
    $accc63f57799543e$var$load("3VIZM"),
    $accc63f57799543e$var$load("gyh6H"),
    $accc63f57799543e$var$load("gBV5J"),
    $accc63f57799543e$var$load("djjX5"),
    $accc63f57799543e$var$load("c0JsV"),
    $accc63f57799543e$var$load("h3ABO"),
    $accc63f57799543e$var$load("iUEjf"),
    $accc63f57799543e$var$load("YAi2k"),
    $accc63f57799543e$var$load("adNrA"),
    $accc63f57799543e$var$load("18TX3"),
    $accc63f57799543e$var$load("eNanj"),
    $accc63f57799543e$var$load("6wr18"),
    $accc63f57799543e$var$load("kzjZo"),
    $accc63f57799543e$var$load("Wowvf"),
    $accc63f57799543e$var$load("cX4Bp"),
    $accc63f57799543e$var$load("dawn8"),
    $accc63f57799543e$var$load("ffEVr"),
    $accc63f57799543e$var$load("hhss7"),
    $accc63f57799543e$var$load("aQh37"),
    $accc63f57799543e$var$load("bJVDE"),
    $accc63f57799543e$var$load("1F7LX"),
    $accc63f57799543e$var$load("3QXpo"),
    $accc63f57799543e$var$load("jnVKv"),
    $accc63f57799543e$var$load("7EorR"),
    $accc63f57799543e$var$load("bgHzk"),
    $accc63f57799543e$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.e207aebd.js.map
